<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf" class="col-12">
            <div class="row mb-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 d-flex justify-content-center">

                    <img src="./../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                </div>
                <div class="col-md-4"></div>
            </div>
            <div class="col-md-12 row mt-5">
                <div class="col-md-6">

                <select class="form-control" v-model="selectedYear" @change="intializeMonths()">
                    <option v-for="year in years" :key="year" :value="year">{{year}}</option>

                  </select>

                </div>

                  <div class="col-md-6">
              <select class="form-control" v-model="selectedDate" @change="monthlySales()">
                    <option v-for="month in months" :key="month.monthNumber" :value="month">{{month.monthName}}</option>

                  </select>
                </div>


            </div>

            <div class="col-md-12 mt-5" v-if="selectedDate">
                    <h4 class="text-center">
                        <span v-if="vid === '34'">Spring Souk</span>
                        <span v-else-if="vid === '47'">Arabian Ranches III</span>
                    </h4>
                  <h4 class="text-center">{{selectedDate.monthName}}</h4>
                  <h5 class="text-center">{{selectedDate.startDate}} to {{selectedDate.endDate}} </h5>
                  <div class="alert alert-danger col-md-12 text-center" role="alert" v-if="hasExistingMontlySale">
                    Transactions for the month of {{selectedDate.monthName}} has already been submitted to EMAAR.
                </div>
            </div>
            <div class="col-md-12 mt-5">
                <div class="well"><h5>Services Report</h5></div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Customer</th>
                            <th>Payment Method</th>
                            <th>Item</th>
                            <th>Status</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Cashier</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td> {{transaction.date}} </td>
                            <td> {{transaction.id}} </td>
                            <th> {{transaction.customer}}</th>
                            <td> {{transaction.payment}} </td>
                            <td> {{transaction.quantity}} </td>
                            <td> {{transaction.status}} </td>
                            <td> {{transaction.taxable}} </td>
                            <td> {{transaction.discount}} </td>
                            <td> {{transaction.vat}} </td>
                            <td> {{transaction.total}} </td>
                            <td> {{transaction.cashier}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{parseFloat(taxable).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(discount).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(vat).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(total).toFixed(2)}} AED </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>


            <div class="col-md-12">
                <div class="well"><h5>Products Report</h5></div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product,idx) in products" :key="product.id + '_' + idx">
                            <td> {{product.date}} </td>
                            <td> {{product.id}} </td>
                            <td> {{product.productname}} - {{product.optionname}} </td>
                            <td> {{product.quantity}} </td>
                            <td> {{product.Taxable}} </td>
                            <td> {{product.discount}} </td>
                            <td> {{product.VAT}} </td>
                            <td> {{product.price}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{parseFloat(productTaxable).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(productDiscount).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(productVat).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(productTotal).toFixed(2)}} AED </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="col-md-12">
                <div class="well"><h5>Other Services Report</h5></div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product,idx) in otherServices" :key="product.id + '_' + idx">
                            <td> {{product.date}} </td>
                            <td> {{product.id}} </td>
                            <td> {{product.title}} - {{product.name}} </td>
                            <td> {{product.quantity}} </td>
                            <td> {{product.Taxable}} </td>
                            <td> {{product.discount}} </td>
                            <td> {{product.VAT}} </td>
                            <td> {{product.price}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{parseFloat(otherServiceTaxable).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(otherServiceDiscount).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(otherServiceVat).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(otherServiceTotal).toFixed(2)}} AED </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="col-md-12">
                <div class="well"><h5>Transaction Summary</h5></div>
                <table class="table table-bordered table-responsive">
                    <tbody>
                        <tr>
                            <td>Total Transaction Count: </td>
                            <td>{{totalTransactionCount}}</td>
                        </tr>
                        <tr>
                            <td>Total Transaction Amount: </td>
                            <td>{{Number(totalAmountWithVat).toLocaleString()}}</td>
                        </tr>
                        <tr>
                            <td>Total VAT Amount: </td>
                            <td>{{totalVAT}}</td>
                        </tr>
                        <tr style="background-color:yellow;">
                            <td>Total Transaction Amount Without VAT: </td>
                            <td>{{Number(totalTransactionAmount).toLocaleString()}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-12">
                <button class="btn btn-primary float-right"  @click="confirmSubmit">Submit to EMAAR</button>
            </div>


        </div>
    </div>
        <div v-else>
            <notfound></notfound>
        </div>
</div>


</template>


<script>
import Swal from 'sweetalert2'
import { DateTime, Info } from "luxon";
export default {

    data(){
        return {
            vid: 0,
            transactions:[],
            products:[],
            payments:[],
            cancelled: [],
            refunded: [],
            users:[],
            drawers: '',
            filters: {
                date: this.$root.myDate,
                draw: 0,
                user: '',
                user_id: this.$root.id,
                name: this.$root.staffname,
            },
            hide: false,
            hasExistingMontlySale: false,
            months: [],
            selectedDate: null,
            otherServices: [],
            years: [],
            selectedYear: 0

        }
    },
    created(){



    },
    mounted(){
        this.vid = new URLSearchParams(window.location.search).get("vid");
        this.intializeYears();
        //this.intializeMonths();
        this.monthlySales();
    },
    methods: {
        intializeYears(){
            var years = []
            var currentDate = DateTime.now();
            var currentYear = currentDate.year;
            var counter = 2022;
            while(counter <= currentYear){
                years.push(counter);
                counter++;
            }
            console.log(years);
            this.years = years;
            this.selectedYear = currentYear;
            this.intializeMonths();
        },
        intializeMonths(){
            this.months = [];
            var months = []
            var currentYear = this.selectedYear;
            var currentDate = DateTime.now();
            var counter = 1;

            _.forEach(Info.months('long'), function(month) {
                var date = DateTime.fromObject({ day: 1, month: counter, year: currentYear })
                var startDate = date.startOf('month');
                var endDate = date.endOf('month');
                var obj = {
                    monthNumber: counter,
                    monthName: month,
                    startDate: startDate.toISODate(),
                    endDate: endDate.toISODate()
                }
                months.push(obj);
                counter++;
            });

            this.months = months;
            var defaultMonth = _.find(months, function(o) { return o.monthNumber == currentDate.month; });
            this.selectedDate = defaultMonth;

        },
        monthlySales() {
            console.log("selectedDate", this.selectedDate)
            if(this.selectedDate == undefined){
                return;
            }
            console.log(this.selectedDate.startDate);
            let self = this;
            axios
            .post('./api/Emaar/Monthly-Sales?vid=' + new URLSearchParams(window.location.search).get("vid"), {
                startDate: this.selectedDate.startDate,
                endDate: this.selectedDate.endDate,
            })
            .then((result) => {
                this.transactions = result.data.transactions;
                this.products = result.data.products;
                this.otherServices = result.data.otherProducts;

                self.checkExistingMontlySale();

            }).catch((err) => {
                console.log(err)
            });
        },
        checkExistingMontlySale(){
                let self = this;
                axios.post("./api/Emaar/Check-Exist-Monthly?vid=" + new URLSearchParams(window.location.search).get("vid"),
                    {
                        startDate: this.selectedDate.startDate,
                        endDate: this.selectedDate.endDate,
                    }
                    )
                .then(response => {
                    self.hasExistingMontlySale = response.data.result;
                })
        },
        confirmSubmit(){
            let self = this;
            Swal.fire({
                title: 'Are you sure you want to submit this transaction to EMAAR?',
                showDenyButton: true,
                showCancelButton: true,
                showLoaderOnConfirm: true,
                 html:
                'Month: <b>' + this.selectedDate.monthName + '</b></br>' +
                'Transaction Count: <b>' + this.totalTransactionCount + '</b></br>' +
                'Transaction Amount: <b>' + Number(this.totalTransactionAmount).toLocaleString() + '</b></br>'
                ,
                confirmButtonText: 'Submit',
                denyButtonText: 'Cancel',
                preConfirm: () => {
                    return axios.post("./api/Emaar/Monthly-Sales/submit",
                        {
                            transactionCount: self.totalTransactionCount,
                            transactionAmount: self.totalTransactionAmount,
                            startDate: self.selectedDate.startDate,
                            endDate: self.selectedDate.endDate,
                            submittedBy: self.filters.name,
                            vid: new URLSearchParams(window.location.search).get("vid")
                        }
                     )
                    .then(response => {
                        if(response.data.result != true){
                            console.log(response.data.error)
                            throw new Error(response.data.error)
                        }
                        return response.data.result;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                        `Request failed: ${error}`
                        )
                    })
                },
                allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal.fire('Transaction submitted to Emaar!', '', 'success')
                    }
                })
        },


    },
    computed: {
        taxable() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discount() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vat() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        total() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        },
        productTaxable(){
            return this.products.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
        },
        productDiscount() {
            return this.products.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        productVat() {
            return this.products.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
        },
        productTotal() {
            return this.products.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        },

        otherServiceTaxable(){
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
        },
        otherServiceDiscount() {
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        otherServiceVat() {
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
        },
        otherServiceTotal() {
            return this.otherServices.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        },

        totalTransactionCount(){
            var productTransactions  = _.uniqBy(this.products, 'id');
            return  this.transactions.length + productTransactions.length + this.otherServices.length;
        },
        totalTransactionAmount(){
            var totalServicesAmount = this.transactions.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0);

            var totalProductsAmount = this.products.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0);

             var totalOtherServicesAmount = this.otherServices.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0);

            return parseFloat(totalServicesAmount + totalProductsAmount + totalOtherServicesAmount).toFixed(2);
        },
        totalVAT(){
            var totalServicesVAT = this.transactions.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0);

            var totalProductsVAT = this.products.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0);

             var totalOtherServicesVAT = this.otherServices.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0);

            return parseFloat(totalServicesVAT + totalProductsVAT + totalOtherServicesVAT).toFixed(2);
        },
        totalAmountWithVat(){
            var totalServicesAmount = this.transactions.reduce((total, item) => {
                return total + Number(item.total)
            }, 0);


            var totalProductsAmount = this.products.reduce((total, item) => {
                return total + Number(item.price)
            }, 0);

             var totalOtherServicesAmount = this.otherServices.reduce((total, item) => {
                return total + Number(item.price)
            }, 0);

               console.log(totalServicesAmount,totalProductsAmount,totalOtherServicesAmount )

            return parseFloat(totalServicesAmount + totalProductsAmount + totalOtherServicesAmount).toFixed(2);
        }
    }
}
</script>





// WEBPACK FOOTER //
// resources/js/Emaar/MonthlySales.vue